"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detailNotFound = exports.detailNotFoundMapStateToProps = void 0;
var classnames_1 = require("classnames");
var Bigpopup_1 = require("@/pages/common/components/Bigpopup");
var Megafoot_1 = require("@/pages/common/components/Megafoot");
var Enquire_1 = require("@/pages/common/components/Enquire");
var Login_1 = require("@/pages/common/components/Login");
var ServerSideSchema_1 = require("@/pages/common/components/schema/ServerSideSchema");
var Signup_1 = require("@/pages/common/components/Signup");
var MegaMenu_1 = require("@/pages/common/components/MegaMenu");
var Breadcrumb_1 = require("@/pages/search/components/Breadcrumb");
var ExistingLogin_1 = require("@/pages/search/components/ExistingLogin");
var React = require("react");
var react_redux_1 = require("react-redux");
var Detail_1 = require("@/pages/detail/components/Detail");
var NotFound_1 = require("@/pages/notFound/components/NotFound");
var ResultItemComponent_1 = require("@/pages/search/components/ResultItemComponent");
var LayoutState_1 = require("@/pages/common/states/LayoutState");
exports.detailNotFoundMapStateToProps = function (state) { return (__assign(__assign({}, state), Detail_1.DetailMapStateToProps(state))); };
exports.detailNotFound = function (props) {
    var renderSoldMessage = function (props) { return (React.createElement("div", { className: "l-notfound__row l-pad-top l-pad-top--2" },
        React.createElement("div", { className: "l-container l-container--lr l-container--nopad" },
            React.createElement("div", { className: "l-container__main" }, Detail_1.renderPropSold(props))))); };
    var renderPropertyInfoRow = function (props) { return (React.createElement("div", { className: "l-notfound__row" },
        React.createElement("div", { className: "l-prophead c-prophead__background" },
            React.createElement("div", { className: "l-prophead__container c-prophead__container" },
                React.createElement("div", { className: "l-prophead__title l-prophead__title--full" },
                    Detail_1.renderTitleGroup(props),
                    Detail_1.renderAddressGroup(props)),
                React.createElement("div", { className: "l-prophead__config l-prophead__config--full" }, Detail_1.renderConfigGroup(props)))))); };
    var renderNotFoundRow = function (props) { return (React.createElement("div", { className: "l-notfound__row l-pad l-pad--4" }, NotFound_1.renderNotFoundSection(__assign(__assign({}, props.notFound), { lang: props.langCode })))); };
    var renderNearbyPropertiesRow = function (props) { return (React.createElement("div", { className: "l-notfound__row" },
        React.createElement("div", { className: "l-container l-container--lr l-container--nopad" },
            React.createElement("div", { className: "l-container__main" }, Detail_1.renderSimilarProperties(props))))); };
    var renderBuildingPropertiesRow = function (props) {
        var renderResultItem = function (it, index) {
            return (React.createElement("div", { className: "c-propertyrow__item", key: index },
                React.createElement(ResultItemComponent_1.default, { item: it, t: props.tResult, filterType: it.type, symbol: props.symbol, googleApi: props.googleApi, lang: props.langCode, onEnquireClicked: props.onSimilarEnquireClicked, onItemClicked: props.onItemClicked })));
        };
        return (React.createElement("div", { className: "l-notfound__row" },
            React.createElement("div", { className: "l-container l-container--lr l-container--nopad" },
                React.createElement("div", { className: "l-container__main" },
                    React.createElement("div", { className: "u-nofav" },
                        React.createElement("div", { className: "l-pad-top--4 l-pad--4" },
                            React.createElement("div", { className: "l-container l-container--lr" },
                                React.createElement("div", { className: "l-container__main" },
                                    React.createElement("div", { className: "t--darker" },
                                        React.createElement("h2", { className: "o-h1 l-pad--2 u-preserve-cap o-h1--center-mobile" }, props.t.sameBuildingProperties)))),
                            React.createElement("div", { className: "c-propertyrow" },
                                React.createElement("div", { className: "c-propertyrow__group" }, props.sameBuilding.results.map(function (it, i) {
                                    return renderResultItem(it, i);
                                })))))))));
    };
    var pageClass = classnames_1.default([
        'l-notfound',
        'c-nav--safari',
        {
            'c-nav__menu-main--mobile-active': props.layout.activePanel === LayoutState_1.ActivePanel.TOPMENU,
            'c-nav__menu-setting--mobile-active': props.layout.activePanel === LayoutState_1.ActivePanel.CONFIG,
        },
    ]);
    // Render
    return (React.createElement("div", { className: pageClass },
        React.createElement("div", { className: "l-notfound__row" },
            React.createElement(MegaMenu_1.default, { nobottom: true })),
        React.createElement("div", { className: "l-notfound__row" },
            React.createElement("div", { className: "l-section l-section--withbg" },
                React.createElement("div", { className: "l-container l-container--lr l-container--lg u-mobile-hidden l-pad-top l-pad t--darker l-container--withbg" },
                    React.createElement(Breadcrumb_1.default, null)))),
        props.showPropertyInfo ? null : renderNotFoundRow(props),
        props.showPropertyInfo ? renderPropertyInfoRow(props) : null,
        props.showPropertyInfo ? renderSoldMessage(props) : null,
        React.createElement("div", { className: "l-notfound__row" },
            React.createElement("div", { className: "l-pad--2 t--darker u-mobile-hidden" },
                React.createElement("div", { className: "c-jumbo c-jumbo--lift" },
                    React.createElement("div", { className: "u-text-center c-actions-multi" },
                        React.createElement("a", { id: "prop-contact-agent-btn", onClick: function () { return props.onEnquireClick(); }, className: "o-btn o-btn--hero", style: { backgroundColor: '#b61229' } },
                            React.createElement("span", { className: "fal fa-envelope" }),
                            "\u00A0",
                            React.createElement("span", null, props.t.contactAgent)))))),
        props.sameBuilding && props.sameBuilding.results.length
            ? renderBuildingPropertiesRow(props)
            : null,
        props.similar.results.length ? renderNearbyPropertiesRow(props) : null,
        React.createElement(Megafoot_1.default, null),
        React.createElement(Enquire_1.default, null),
        React.createElement(ServerSideSchema_1.default, null),
        React.createElement(Signup_1.default, null),
        React.createElement(Login_1.default, null),
        React.createElement(Bigpopup_1.default, null),
        React.createElement(ExistingLogin_1.default, null)));
};
exports.default = react_redux_1.connect(exports.detailNotFoundMapStateToProps, Detail_1.DetailMapDispatchToProps)(exports.detailNotFound);
